var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"fill":"none","stroke":"currentColor","stroke-width":"1.5","viewBox":"0 0 24 24","xmlns":"http://www.w3.org/2000/svg","aria-hidden":"true"}},[_c('path',{attrs:{"stroke-linecap":"round","stroke-linejoin":"round","d":"M21 21l-5.197-5.197m0 0A7.5 7.5 0 105.196 5.196a7.5 7.5 0 0010.607 10.607z"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }